import React from "react"
import { RichText as PrismicRichText } from "prismic-reactjs"

import AppStoreButtons from "legacy/components/shared/AppStoreButtons"
import { Element, Text } from "legacy/components/shared/base"
import HeroButtons from "./HeroButtons"
import { Maybe } from "types/Maybe"
import { PrismicPageDataBodySplitHero } from "types/__generated__/gatsby-graphql"

interface OwnProps {
  data: Maybe<PrismicPageDataBodySplitHero>
}

type HeroTextProps = OwnProps

const HeroText: React.FC<HeroTextProps> = ({
  data,
}): React.ReactElement | null => {
  if (!data) return null

  const appStoreButtons = data.primary?.app_store_buttons
  const headline = data.primary?.headline?.richText
  const headlineType = headline[0].type
  const headlineSize =
    headlineType === "heading1"
      ? ["36", "text.header", "text.header", "text.headerLarge"]
      : ["28", "28", "text.header"]
  const intro = data.primary?.intro
  const repeater = data.items

  return (
    <Element
      alignItems="center"
      display="flex"
      gridColumnEnd={["span 12", "span 12", "span 6"]}
      gridColumnStart={["1", "1", "7"]}
      justifyContent="center"
      p={["0 20px", "0 8%", "20px 15px 20px 0"]}
    >
      <Element
        maxWidth={["450px", "none", "460px"]}
        width={["100%", "100%", "95%"]}
      >
        <Text
          as="div"
          fontSize={headlineSize}
          lineHeight="1.38"
          maxWidth={["500px", "none", "none"]}
          mb={["20", "20", "35"]}
          variant="header"
        >
          {PrismicRichText.render(headline)}
        </Text>
        <Text
          as="p"
          fontSize={["17", "text.body"]}
          lineHeight={["28px", "1.8"]}
          mb={["30", "30", "55"]}
        >
          {intro}
        </Text>
        <Element mb={["20", "30", "0"]}>
          {appStoreButtons ? (
            <AppStoreButtons desktopAlignment="left" mobileAlignment="left" useQRCode={true} />
          ) : null}
          {!appStoreButtons && repeater && repeater.length > 0 ? (
            <HeroButtons data={repeater} />
          ) : null}
        </Element>
      </Element>
    </Element>
  )
}

export default HeroText
